export default __webpack_public_path__ + "static/media/b2.2de25c9a.jpg";